export default __webpack_public_path__ + "static/media/menu.eb3a0b21.svg";